import { doc, getDoc } from 'firebase/firestore';

import { FSCollections } from '@src/constants/database';
import { db } from '@src/firebase/firebase';
import ScheduleTemplate from '@src/models/ScheduleTemplate';
import { apiCallable } from '@src/util/cloud-functions/apiClient';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';
import safeExecute from '@src/util/safeExecute';

class ScheduleTemplateRepository {

  getTemplatePath(orgId, divId, templateId) {
    return `${FSCollections.ORGANIZATIONS}/${orgId}/${FSCollections.DIVISIONS}/${divId}/${FSCollections.SCHEDULE_TEMPLATES}/${templateId}`;
  }
  
  /**
   * Get a schedule template by organization, division and template id
   * @param {string} orgId - Organization ID
   * @param {string} divId - Division ID
   * @param {string} templateId - Template ID
   * @returns {Promise<ScheduleTemplate|null>} Schedule template or null if not found
   */
  async get(orgId, divId, templateId) {
    return safeExecute(async () => {
      if (!orgId || !divId || !templateId) {
        return null;
      }

      const templateDocRef = doc(
        db,
        this.getTemplatePath(orgId, divId, templateId)
      );

      const templateDoc = await getDoc(templateDocRef);
      const templateData = templateDoc.exists() ? templateDoc.data() : null;

      return ScheduleTemplate.fromFirestore(templateData, divId);
    });
  }
  
  async listElastic(params){
    return safeExecute(async () => {
      const genericFindFn = apiCallable(API_OPERATIONS.QUERY);
      const response = await genericFindFn(params);
      const responseData = response.data;
      if (!responseData?.hits) return { templates: [], total: 0 };

      return responseData;
    });
  }
}

export default ScheduleTemplateRepository;